import React, { Component, PropTypes } from 'react'
import xtend from 'xtend'
import Switch from 'react-bootstrap-switch'

import TwitterFeedTypeDetector from './TwitterFeedTypeDetector'

/*
    showTwitterFeed: {
        displayName: "Display a Twitter Feed",
        value: false,
        description: "",
        inputType: "twitter",
        context: {
            value: "",
            widgetType: "",
            type: "user",
            options: [
                "user",
                "widget"
            ]
        }
    }
*/

class TwitterFeed extends Component {
    constructor (props) {
        super(props)

        this.state = {
            widgetError: false
        }
        
        this.handleTimelineTypeChange = this.handleTimelineTypeChange.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
    }

    handleTimelineTypeChange (type) {
        this.props.storeEdits(
            null,
            xtend(this.props.context, {
                type: type
            })
        )
    }

    handleInputChange (ev) {
        const value = ev.target.value
        if (this.props.context.type == 'user') {
            this.props.storeEdits(
                null,
                xtend(this.props.context, {
                    value: value
                })
            )
        } else {
            let widgetType = false
            
            let match = TwitterFeedTypeDetector.detectType(value)
            let context = (match !== false) ?
                TwitterFeedTypeDetector.parseValues(match, value) :
                false

            console.log('match', match, context);
            

            if (context === false) {
                this.setState({
                    widgetError: true
                })
            } else {
                // Defer state update
                this.setState(() => {
                    widgetError: false
                })
                
                this.props.storeEdits(
                    null,
                    xtend(this.props.context, {
                        value: context.value,
                        widgetType: context.widgetType,
                        type: 'widget'
                    })
                )
            }
        }
    }

    render () {
        let { widgetError } = this.state
        let { context, value } = this.props

        const timelineTypeOpts = context.options.map(function (opt, i) {
            const handler = this.handleTimelineTypeChange.bind(null, opt)

            return (<label key={i} onClick={handler}>
                {opt.capitalizeWord()}
                <input type="radio"
                    autoComplete="off"
                    checked={value === false ? false :
                        context.type == opt}
                    onChange={handler}
                />
            </label>)
        }, this)
        
        return <div id="twitter-feed">
            
            <p>To generate the code for a Widget visit the <a href="https://publish.twitter.com/" target="_blank" rel="noopener noreferrer">Twitter Widget Creator</a>.</p>
            
            <div className="row">
                <div className="col-sm-4">
                    <div className="group">
                        <label>Enabled:</label>
                        <Switch
                            value={value}
                            onChange={(el, state) => this.props.storeEdits(state)}
                            animate={false}
                            onText="On"
                            offText="Off"
                        />
                    </div>
                    <div className="group">
                        <label>Feed Type:</label>
                        <div className="btn-group" data-toggle="buttons">
                            {timelineTypeOpts}
                        </div>
                    </div>
                </div>
                <div className="col-sm-8">
                    <div className="input-group">
                        <div className="input-group-addon">
                            {context.type == 'user' ?
                                'User Timeline' :
                                'Widget' + ((!!context.widgetType) ? ': ' + context.widgetType : '')
                            }
                        </div>

                        <input type="text"
                            readOnly={!value}
                            placeholder={(context.type == 'user') ?
                                "Enter User Name" :
                                "Paste Widget Code Here"
                            }
                            className="form-control"
                            value={context.value}
                            onChange={this.handleInputChange} />
                    </div>

                    {widgetError ? <div className="alert alert-warning">
                        <p>We could not detect the type of the Twitter Widget based on the input provided.</p>
                        <p>If only a <strong>Twitter User Profile</strong> is desired, select "User" and enter only the Twitter User Name.</p>
                        <p>Also check: <a href="https://publish.twitter.com/" target="_blank" rel="noopener noreferrer">Twitter Widget Creator</a></p>
                    </div> : null}
                </div>
            </div>
        </div>
    }
}

TwitterFeed.propTypes = {}

export default TwitterFeed